import { Reporte606Service } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const Reporte606Manager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const imprimirPDF = () =>
    Reporte606Service.imprimirPDF().then((res) => {
      if (!res.Success) handleException(res);
      return res.Data;
    });

  const descargarExcel = () =>
    Reporte606Service.descargarExcel().then((res) => {
      if (!res.Success) handleException(res);
      return res.blob;
    });

  const descargarCSV = () =>
    Reporte606Service.descargarCSV().then((res) => {
      if (!res.Success) handleException(res);
      return res.blob;
    });

  return { imprimirPDF, descargarExcel, descargarCSV };
})();
